import { Button } from '@novaquantis/design-system';
import OnboardingInfoBox from '../../../components/onboarding/OnboardingInfoBox';
import OnboardingStepActions from '../../../components/onboarding/OnboardingStepActions';
import { ALPACA_LINKS } from '../../../onboarding/onboardingSteps';
import {
  stepTitleClass,
  stepLeadClass,
  stepBodyClass,
  stepFootnoteClass,
  stepLinkSecondaryClass,
} from './stepStyles';

type Props = {
  onContinue: () => void;
  continuing: boolean;
};

const AlpacaSignupStep = ({ onContinue, continuing }: Props) => (
  <div>
    <h1 className={stepTitleClass}>Create your Alpaca account</h1>
    <p className={stepLeadClass}>
      NovaQuantis connects to your brokerage via Alpaca&apos;s Trading API. Alpaca is a
      FINRA-member broker-dealer and provides API-first access to U.S. equities.
    </p>
    <OnboardingInfoBox variant="navy" title="Why Alpaca?">
      <ul className="list-disc">
        <li>Regulated U.S. broker-dealer infrastructure</li>
        <li>Separate paper and live trading environments</li>
        <li>Dashboard tools to manage API keys after account approval</li>
      </ul>
    </OnboardingInfoBox>
    <p className={stepBodyClass}>
      Open a new individual account (use the same email you were invited with if possible).
    </p>
    <OnboardingStepActions>
      <a href={ALPACA_LINKS.signup} target="_blank" rel="noopener noreferrer">
        <Button variant="outline">Open Alpaca signup</Button>
      </a>
      <Button type="button" onClick={onContinue} disabled={continuing} variant="glow">
        {continuing ? 'Saving…' : "I've created my account"}
      </Button>
    </OnboardingStepActions>
    <p className={stepFootnoteClass}>
      <a
        className={stepLinkSecondaryClass}
        href={ALPACA_LINKS.registerGuide}
        target="_blank"
        rel="noopener noreferrer"
      >
        Step-by-step: Register on Alpaca
      </a>
    </p>
  </div>
);

export default AlpacaSignupStep;
